import { Skeleton } from '@sr/ui-library';
import { SkeletonRegion } from '../SkeletonRegion';

interface BankDetailsSkeletonProps {
  /**
   * Accounts already in the store. The multi-bank flag can only shrink that
   * list, so it is the upper bound on what will be on screen.
   */
  cardCount: number;
  /** Grid classes of the real list, so the placeholder wraps the way it will. */
  cardGridClassName: string;
  /** Reserves the heading's trailing button, on surfaces that have one. */
  hasAction?: boolean;
}

/**
 * Placeholder for the bank details heading and card list while the multi-bank
 * feature flag is in flight. Both the heading and the number of visible cards
 * depend on that flag, so neither can be painted honestly before it resolves:
 * rendering nothing drops the "Add Bank Account" button and shifts the page
 * when the header lands, and rendering the unfiltered list briefly exposes an
 * account the flag is meant to hide.
 */
export const BankDetailsSkeleton = ({
  cardCount,
  cardGridClassName,
  hasAction,
}: BankDetailsSkeletonProps) => (
  <SkeletonRegion label="Loading bank accounts" className="space-y-6">
    {/* The h2 is `text-xl`, so a 28px line box. */}
    <div className="flex items-center justify-between gap-4">
      <Skeleton className="h-7 w-48" />

      {hasAction && <Skeleton className="h-8 w-44" />}
    </div>

    <div className={cardGridClassName}>
      {Array.from({ length: cardCount }).map((_, index) => (
        <Skeleton key={index} className="h-28 w-full" />
      ))}
    </div>
  </SkeletonRegion>
);
